import { pushAlert } from '@/services/messages/alertService';
import Http from '@/services/http';
import { Captcha } from 'sigma-mappings';

export default {
  getCaptcha() {
    const http = new Http();
    return http.get('/Captcha');
  },

  replyCaptcha({ validationKey, value }) {
    const http = new Http({
      errorHandling: {
        // O componente de captcha do back-end necessita de tratamentos específicos,
        // por isso o controle de erros global foi desabilitado aqui.
        ignore: true,
      },
    });
    return http.post('/Captcha', new Captcha({ validationKey, value }), {
      withCredentials: true,
    }).catch(() => {
      pushAlert({ code: 'MA003' });
      return Promise.reject();
    });
  },
};
